module.exports = __webpack_public_path__ + "static/img/bottom@2x.0115f16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/ktb_min/bottom@2x.png
// module id = ZSRz
// module chunks = 70